module.exports = __webpack_public_path__ + "static/media/14.a8fa72ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/14.png
// module id = 1224
// module chunks = 0